import { render, staticRenderFns } from "./LegacyWebHostingService.vue?vue&type=template&id=9069b05a&"
import script from "./LegacyWebHostingService.vue?vue&type=script&lang=js&"
export * from "./LegacyWebHostingService.vue?vue&type=script&lang=js&"
import style0 from "./LegacyWebHostingService.vue?vue&type=style&index=0&id=9069b05a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports